import React from "react";

const ModalDataTable = ({ headers, data }) => {
  console.log(data);
  
  if (data.filter((item) => typeof item != "undefined").length > 0) {
    return (
      <table className="w-full min-w-1/2 divide-y divide-black-200 border border-black-300">
        <thead className="bg-blue-500 max-w-[300px] text-white border-b border-black-300">
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                className="px-1.5 py-3 text-left text-md font-bold uppercase border-r border-black-300"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white max-w-[300px] divide-y divide-black-200">
          {data.map((row, index) => (
            <tr key={index}>
              {Object.values(row).map((value, i) => (
                <td
                  key={i}
                  className="px-6 py-4 max-w-[300px] md:max-w-[180px] overflow-hidden whitespace-nowrap text-md text-black-500 font-bold border-b border-black-300 border-r"
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return null; // Return null if no data to display
};

export default ModalDataTable;
